import { Link, ResponsiveImage } from "@quintype/components";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { object } from "prop-types";
import get from "lodash/get";

import "./author-info.m.css";

const AuthorInfo = ({ story }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = get(qtState, ["pageType"], null);
  const authorData = get(story, ["authors", "0"]);
  const byline1 = get(story, ["metadata", "story-attributes", "byline1"], null);
  const byline2 = get(story, ["metadata", "story-attributes", "byline2"], null);
  const authorName =
    authorData.name === (byline1 && byline1.toString().replace(/"/, " ")) ||
    authorData.name === (byline2 && byline2.toString().replace(/"/, " "))
      ? ""
      : authorData.name;
  const [isPublicAuthor, setIsPublicAuthor] = useState(false);
  const slug = `/author/${authorData.slug}`;

  const getIsPublicAuthor = async () => {
    const { author } = await (await fetch(`/api/v1/authors/${authorData.id}`)).json();

    if (author) {
      const publicAuthor = get(author, ["metadata", "Public Author"], "no");
      setIsPublicAuthor(publicAuthor.toLowerCase() === "yes");
    }
  };

  useEffect(() => {
    getIsPublicAuthor();
  }, []);

  const getAuthorImage = () => {
    if (authorData["avatar-s3-key"]) {
      return (
        <ResponsiveImage
          slug={authorData["avatar-s3-key"]}
          metadata={authorData.metadata || ""}
          imgParams={{ auto: ["format", "compress"] }}
          className="author-image"
          alt={authorData.name}
        />
      );
    } else if (authorData["avatar-url"]) {
      return (
        <img
          styleName="author-image"
          className="contributor-image"
          src={authorData["avatar-url"]}
          alt={authorData.name}
          width=""
          height=""
        />
      );
    } else {
      return null;
    }
  };

  if (isPublicAuthor) {
    return (
      <div styleName="wrapper">
        {getAuthorImage()}
        <span className="author-name" data-test-id="story-author-pub">
          <Link href={slug} aria-label="placeholder">
            {pageType === "story-page" ? authorName : authorData.name}
          </Link>
          {byline1 && (
            <span
              styleName={
                pageType === "story-page"
                  ? `byline ${authorName ? "byline-prefix byline-space" : ""}`
                  : `byline byline-prefix byline-space`
              }
            >
              {byline1}
            </span>
          )}
          {byline2 && (
            <span
              styleName={
                pageType === "story-page"
                  ? `byline ${authorName || byline1 ? "byline-prefix byline-space" : ""}`
                  : `byline byline-prefix byline-space`
              }
            >
              {byline2}
            </span>
          )}
        </span>
      </div>
    );
  }

  return (
    <div styleName="wrapper">
      {getAuthorImage()}
      <span className="author-name" data-test-id="story-author">
        {pageType === "story-page" && authorName && <span styleName="main-author">{authorName}</span>}
        {pageType !== "story-page" && authorData.name && <span styleName="main-author">{authorData.name}</span>}
        {byline1 && (
          <span
            styleName={
              pageType === "story-page"
                ? `byline ${authorName ? "byline-prefix byline-space" : ""}`
                : `byline byline-prefix byline-space`
            }
          >
            {byline1}
          </span>
        )}
        {byline2 && (
          <span
            styleName={
              pageType === "story-page"
                ? `byline ${authorName || byline1 ? "byline-prefix byline-space" : ""}`
                : `byline byline-prefix byline-space`
            }
          >
            {byline2}
          </span>
        )}
      </span>
    </div>
  );
};

AuthorInfo.propTypes = {
  story: object,
};

export default AuthorInfo;
